<template>
  <div>
    <div class="form-wrap">
      <div class="form-list py-2 px-3">

        <!-- 補足説明-->
        <div class="row pt-2 form-description-area">
          <p class="col-12" ><trans-text i18nKey="ui[12][2]" :isHtml="true"/></p>
          <p class="col-12" ><trans-text i18nKey="ui[12][3]" :isHtml="true"/></p>
        </div>
        <div class="col-12 form-hr">
          <hr class="">
        </div>

        <!-- 画面遷移UI -->
        <div class="row text-center">
          <div class="offset-1 offset-lg-3 col-10 col-lg-6">
            <div class="my-4">
              <router-link tag="button" class="btn w-100 btn-lg btn-default" :to="{ name: 'top', params:{} }">
                <trans-text i18nKey="ui[12][4]"/>
              </router-link>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    components: {
    },
    data () {
      return {
      }
    },
    created(){
    },
    methods:{
    }
  }
</script>


<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// PageForm.vue?dbf8ade0